// import Session from "./session";
import { push } from "react-router-redux";
import { SERVICE_ENDPOINT } from "../common/constants";
import { compose } from "redux";
import { showAlert, displayMessage } from "./alertHelper";
import { getMessage } from "./Messages";
import Session from "./session";
import FileSaver from "file-saver";
import history from "./history";

export const apiCall = (
  endpoint,
  method = "GET",
  data = {},
  headers = {},
  cache = "no-cache",
  mode = "cors"
) => {
  // if (!Session.isAuthenticated()) {
  //   throw new Error("Session expired");
  // }

  // const user = JSON.parse(Session.getItem("user"));
  // debugger;
  // if (navigator.onLine) {
  //   displayMessage("please check your intennet connection");
  //   return;
  // }

  const fullUrl = endpoint;
  let _headers = new Headers({
    Accept: "application/json",
    "Content-Type": "application/json",
  });
  Object.keys(headers).forEach((key) => {
    _headers.append(key, headers[key]);
  });

  let request = {};

  if (method !== "GET") {
    request = new Request(fullUrl, {
      method: method,
      mode: mode,
      cache: cache,
      headers: _headers,
      credentials: "include",
      // redirect: "follow",
      body: JSON.stringify(data),
    });
  } else {
    request = new Request(fullUrl, {
      method: method,
      mode: mode,
      cache: cache,
      headers: _headers,
      // redirect: "follow",
      credentials: "include",
    });
  }
  return fetch(request)
    .then((res) => {
      /*This block is to navigate to login page when session expires*/
      if (res.redirected) {
        showAlert(getMessage("session_expired"));

        setTimeout(() => {
          Session.logout();
          history.push("/login");
        }, 3000);
      }

      if (!res.ok) {
        console.log("Response is not  OK");
        return Promise.reject(res);
      } else console.log("response is  OK");

      // console.log(" res  " + JSON.stringify(res));
      return res.json();
    })
    .catch((error) => {
      // console.log("API call Error : ", error);
      console.error(error); //eslint-disable-line no-console
      throw new Error(error.message || " Network request failed");
    });
};

export const validateEmailAddress = (url, method, body) => {
  // console.log("Request Body : " + JSON.stringify(body));
  const user = Session.getItem(Session.CURRENT_USER_NAME);
  body.username = user;
  return fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  }).then((response) => {
    if (response.redirected) {
      showAlert(getMessage("session_expired"));

      setTimeout(() => {
        Session.logout();
        history.push("/login");
      }, 3000);
    }
    return response.json();
  });
};
export const fileUpload = (url, method, file) => {
  //console.log("Request Body : " + JSON.stringify(file));
  let fileData = new FormData();
  fileData.append("username", Session.getItem(Session.CURRENT_USER_NAME));
  fileData.append("file", file[0]);
  // console.log(fileData);
  let formHeaders = new Headers({
    username: Session.getItem(Session.CURRENT_USER_NAME),
  });
  return fetch(url, {
    method: "POST",
    headers: formHeaders,
    body: fileData,
    credentials: "include",
  }).then((response) => {
    if (response.redirected) {
      showAlert(getMessage("session_expired"));

      setTimeout(() => {
        Session.logout();
        history.push("/login");
      }, 3000);
    }
    return response.json();
  });
};

export const loadUploadedFiles = (url, method, body) => {
  return fetch(url, {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    credentials: "include",
  }).then((response) => {
    if (response.redirected) {
      showAlert(getMessage("session_expired"));

      setTimeout(() => {
        Session.logout();
        history.push("/login");
      }, 3000);
    }
    return response.json();
  });
};
export const validateBulkEmails = (url, method, body) => {
  return fetch(url, {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    credentials: "include",
  }).then(async (response) => {
    if (response.redirected) {
      showAlert(getMessage("session_expired"));

      setTimeout(() => {
        Session.logout();
        history.push("/login");
      }, 3000);
    }
    response = await response.json();
    if(response.success){
      showAlert(getMessage("verification_under_progress"))
    }
    return response
  });
};
// re validation
export const reValidateBulkEmails = (url, method, body) => {
  return fetch(url, {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    credentials: "include",
  }).then((response) => {
    if (response.redirected) {
      showAlert(getMessage("session_expired"));

      setTimeout(() => {
        Session.logout();
        history.push("/login");
      }, 3000);
    }
    return response.json();
  });
};

export const deleteFileBulkEmails = (url, method, body) => {
  return fetch(url, {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    credentials: "include",
  }).then((response) => {
    if (response.redirected) {
      showAlert(getMessage("session_expired"));

      setTimeout(() => {
        Session.logout();
        history.push("/login");
      }, 3000);
    }
    return response.json();
  });
};
export const DownloadReportService = (url, method, body) => {
  // console.log("body : " + JSON.stringify(body));
  return fetch(url, {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    credentials: "include",
  }).then((response) => {
    if (response.redirected) {
      showAlert(getMessage("session_expired"));

      setTimeout(() => {
        Session.logout();
        history.push("/login");
      }, 3000);
    }
    const match = response.headers
      .get("content-disposition")
      .match(/"([^"]*)"/);
    const fileName = match && match[1] ? match[1] : "results.csv";

    const decodedFileName = decodeURIComponent(fileName);
    // console.log("Download File Name:" + fileName);
    // console.log(JSON.stringify(response.headers));
    response.blob().then((blob) => FileSaver.saveAs(blob, decodedFileName));
  });
};
export const loadEmailsList = (url, method, body) => {
  return fetch(url, {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    credentials: "include",
  }).then((response) => {
    if (response.redirected) {
      showAlert(getMessage("session_expired"));

      setTimeout(() => {
        Session.logout();
        history.push("/login");
      }, 3000);
    }
    return response.json();
  });
};



// WEBPACK FOOTER //
// ./src/utility/apiCall.js